import React, { useState } from 'react';
import { sendContactMessage, submitPrayerRequest } from '../services/api';
import './Contact.css';

const INIT_MSG = { name: '', email: '', phone: '', subject: '', message: '' };
const INIT_PRAYER = { name: '', email: '', request: '', is_anonymous: false };

export default function Contact() {
  const [tab, setTab] = useState('contact');

  // Contact form
  const [msgForm, setMsgForm] = useState(INIT_MSG);
  const [msgStatus, setMsgStatus] = useState(null); // null | 'sending' | 'ok' | 'error'
  const [msgError, setMsgError] = useState('');

  // Prayer form
  const [prayerForm, setPrayerForm] = useState(INIT_PRAYER);
  const [prayerStatus, setPrayerStatus] = useState(null);
  const [prayerError, setPrayerError] = useState('');

  const handleMsgChange = (e) => {
    const { name, value } = e.target;
    setMsgForm((f) => ({ ...f, [name]: value }));
  };

  const handleMsgSubmit = async (e) => {
    e.preventDefault();
    setMsgStatus('sending');
    setMsgError('');
    try {
      await sendContactMessage(msgForm);
      setMsgStatus('ok');
      setMsgForm(INIT_MSG);
    } catch (err) {
      const detail = err?.response?.data?.error || 'Une erreur est survenue. Réessayez.';
      setMsgError(detail);
      setMsgStatus('error');
    }
  };

  const handlePrayerChange = (e) => {
    const { name, value, type, checked } = e.target;
    setPrayerForm((f) => ({ ...f, [name]: type === 'checkbox' ? checked : value }));
  };

  const handlePrayerSubmit = async (e) => {
    e.preventDefault();
    setPrayerStatus('sending');
    setPrayerError('');
    try {
      await submitPrayerRequest(prayerForm);
      setPrayerStatus('ok');
      setPrayerForm(INIT_PRAYER);
    } catch (err) {
      const detail = err?.response?.data?.error || 'Une erreur est survenue. Réessayez.';
      setPrayerError(detail);
      setPrayerStatus('error');
    }
  };

  return (
    <div className="contact-page">
      <div className="page-banner">
        <div className="container">
          <h1>Contact</h1>
          <p>Nous sommes là pour vous</p>
        </div>
      </div>

      <section className="section">
        <div className="container contact-layout">
          {/* Info Panel */}
          <aside className="contact-info">
            <h2>Venez nous rendre visite</h2>
            <div className="gold-bar" />
            <div className="info-items">
              <div className="info-item">
                <span className="info-item__icon">📍</span>
                <div>
                  <strong>Adresse</strong>
                  <p>Saint-Marc, Haïti</p>
                </div>
              </div>
              <div className="info-item">
                <span className="info-item__icon">📞</span>
                <div>
                  <strong>Téléphone</strong>
                  <p>+509 3651-8509</p>
                </div>
              </div>
              <div className="info-item">
                <span className="info-item__icon">✉️</span>
                <div>
                  <strong>Email</strong>
                  <p>contact@miprecch.com</p>
                </div>
              </div>
            </div>

            <div className="service-times-panel">
              <h3>Horaires de Culte</h3>
              <ul>
                <li><strong>Dimanche</strong> — 7h00 AM & 9h00 AM</li>
                <li><strong>Mercredi</strong> — 6h00 PM (Combat Spirituel)</li>
                <li><strong>Vendredi</strong> — 9h00 PM (Veillée de nuit)</li>
              </ul>
            </div>
          </aside>

          {/* Forms Panel */}
          <div className="contact-forms">
            {/* Tabs */}
            <div className="form-tabs">
              <button
                className={`form-tab${tab === 'contact' ? ' form-tab--active' : ''}`}
                onClick={() => setTab('contact')}
              >
                ✉️ Envoyer un Message
              </button>
              <button
                className={`form-tab${tab === 'prayer' ? ' form-tab--active' : ''}`}
                onClick={() => setTab('prayer')}
              >
                🙏 Demande de Prière
              </button>
            </div>

            {/* Contact Form */}
            {tab === 'contact' && (
              <form className="form-card" onSubmit={handleMsgSubmit} noValidate>
                {msgStatus === 'ok' && (
                  <div className="form-success">
                    ✅ Votre message a été envoyé! Nous vous répondrons bientôt.
                  </div>
                )}
                {msgStatus === 'error' && (
                  <div className="form-error">❌ {msgError}</div>
                )}
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Nom complet *</label>
                    <input
                      id="name"
                      name="name"
                      type="text"
                      value={msgForm.name}
                      onChange={handleMsgChange}
                      placeholder="Jean Pierre"
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={msgForm.email}
                      onChange={handleMsgChange}
                      placeholder="jean@exemple.com"
                      required
                    />
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Téléphone</label>
                    <input
                      id="phone"
                      name="phone"
                      type="tel"
                      value={msgForm.phone}
                      onChange={handleMsgChange}
                      placeholder="+509 XXXX-XXXX"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Sujet</label>
                    <input
                      id="subject"
                      name="subject"
                      type="text"
                      value={msgForm.subject}
                      onChange={handleMsgChange}
                      placeholder="Sujet de votre message"
                    />
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor="message">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={msgForm.message}
                    onChange={handleMsgChange}
                    rows={5}
                    placeholder="Écrivez votre message ici..."
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary form-submit"
                  disabled={msgStatus === 'sending'}
                >
                  {msgStatus === 'sending' ? 'Envoi...' : 'Envoyer le Message'}
                </button>
              </form>
            )}

            {/* Prayer Form */}
            {tab === 'prayer' && (
              <form className="form-card" onSubmit={handlePrayerSubmit} noValidate>
                {prayerStatus === 'ok' && (
                  <div className="form-success">
                    🙏 Votre demande de prière a été reçue. Nous prierons pour vous!
                  </div>
                )}
                {prayerStatus === 'error' && (
                  <div className="form-error">❌ {prayerError}</div>
                )}
                <p className="form-intro">
                  Partagez votre besoin de prière avec notre équipe. Votre demande restera
                  confidentielle si vous le souhaitez.
                </p>
                <div className="form-group">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      name="is_anonymous"
                      checked={prayerForm.is_anonymous}
                      onChange={handlePrayerChange}
                    />
                    Soumettre de manière anonyme
                  </label>
                </div>
                {!prayerForm.is_anonymous && (
                  <div className="form-row">
                    <div className="form-group">
                      <label htmlFor="p-name">Votre nom</label>
                      <input
                        id="p-name"
                        name="name"
                        type="text"
                        value={prayerForm.name}
                        onChange={handlePrayerChange}
                        placeholder="Jean Pierre"
                      />
                    </div>
                    <div className="form-group">
                      <label htmlFor="p-email">Email (optionnel)</label>
                      <input
                        id="p-email"
                        name="email"
                        type="email"
                        value={prayerForm.email}
                        onChange={handlePrayerChange}
                        placeholder="jean@exemple.com"
                      />
                    </div>
                  </div>
                )}
                <div className="form-group">
                  <label htmlFor="p-request">Votre demande *</label>
                  <textarea
                    id="p-request"
                    name="request"
                    value={prayerForm.request}
                    onChange={handlePrayerChange}
                    rows={6}
                    placeholder="Partagez votre besoin de prière..."
                    required
                  />
                </div>
                <button
                  type="submit"
                  className="btn btn-primary form-submit"
                  disabled={prayerStatus === 'sending'}
                >
                  {prayerStatus === 'sending' ? 'Envoi...' : '🙏 Soumettre la Demande'}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
